import { render, staticRenderFns } from "./my-phone-input.vue?vue&type=template&id=0c713c44&scoped=true&"
import script from "./my-phone-input.vue?vue&type=script&lang=js&"
export * from "./my-phone-input.vue?vue&type=script&lang=js&"
import style0 from "./my-phone-input.vue?vue&type=style&index=0&id=0c713c44&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c713c44",
  null
  
)

export default component.exports